import React from "react";
import { Typography, TableCellList } from "common";

export function OrderDetailsTableCell({ id, label, bolNum }) {
  return (
    <TableCellList>
      <Typography component="li" fontSize="large" value={id || "N/A"} />
      <Typography component="li" label value={label || "N/A"} />
      <Typography
        component="li"
        fontWeight="bold"
        fontSize="medium"
        value={bolNum || "N/A"}
      />
    </TableCellList>
  );
}
